// extracted by mini-css-extract-plugin
module.exports = {"buttonSecondaryDanger":"ButtonSecondaryDanger_buttonSecondaryDanger__3aMCD"};